/* eslint-disable react/style-prop-object */
import React from "react";
import { LookerCookielessFrame } from "@episerver/looker-dashboard";
import { useSession } from "../../../../hooks/useSession/useSession";
import { useUserContext } from "../../../../providers/UserProvider";
import styles from "../../Usage/Usage.module.scss";
import { config } from "../../../../config";
import { ADMINCENTER_PRODUCT_ID } from "../../../../constants/constants";

export const MasterDashboard = () => {
    const { accessToken } = useSession();
    const { organizationId } = useUserContext();

    return (
        <div className={styles["usage-page"]}>
            <LookerCookielessFrame
                env={config.APP_ENVIRONMENT}
                accessToken={accessToken!!}
                organizationId={organizationId!!}
                productId={process.env.REACT_APP_MASTERDASHBOARD_PRODUCT_ID!!}
                adminCenterProductId={ADMINCENTER_PRODUCT_ID}
            />
        </div>
    );
};

MasterDashboard.displayName = "MasterDashboard";
